import React from 'react'
import classnames from 'classnames/bind'
import styles from './Badge.module.css'

const cx = classnames.bind(styles)

export type BadgeVariant =
  | 'profile'
  | 'urgent'
  | 'points'
  | 'success'
  | 'info'
  | 'warning'
  | 'neutral'
  | 'danger'

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
  children: React.ReactNode
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'neutral',
  className,
  children,
  ...rest
}) => {
  return (
    <span className={cx('badge', variant, className)} {...rest}>
      {children}
    </span>
  )
}

export default Badge
